var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_550_941)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_550_941)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M884.21 100H0V700H884.21V100Z",
    fill: "#436F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.21 100H0V500H884.21V100Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.21 100H0V300H884.21V100Z",
    fill: "#CD2A3E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_550_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_550_941"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 884.21,
    height: 600,
    fill: "white",
    transform: "translate(0 100)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHu);
export default __webpack_public_path__ + "static/media/hu.ff8a6303ff0088d07e3f1d56424249fc.svg";
export { ForwardRef as ReactComponent };